import { useEffect } from 'react';
import moment from 'moment';
import { OwnReservation } from 'types/Reservation';

const useAssertDanalockTokenPresent = (reservation: OwnReservation, isRefetching: boolean, refetch: () => void) => {
    const isInFuture = moment().isBefore(moment.unix(reservation.start_at));
    const isInPast = moment().isAfter(moment.unix(reservation.end_at));

    useEffect(() => {
        // IF we are missing the danalock tokens we need to refresh data
        if (isRefetching || isInFuture || isInPast) {
            return;
        }
        if (
            reservation.booked.locks?.find((item) => {
                if (item.type === 'danalock' || item.type === 'danalockRelay') {
                    return !item.token || (item.has_pin && !item.pin);
                }
                return false;
            })
        ) {
            refetch();
        }
    }, [isInFuture, isInPast, isRefetching, refetch, reservation.booked.locks]);
};

export default useAssertDanalockTokenPresent;
